import { Laptop, Smartphone } from "lucide-react";
import { APDisc, C, Draw, Icon, Label, Packet, Pop, Svg, Unit, useCycle } from "./shared";

const LINES = [
  "Access points sit neatly on the ceiling, placed where a proper survey says they should go.",
  "Each one is cabled back to your comms rack — labelled, tested and tidy.",
  "Laptops and phones hop between access points as people walk around — no drop-outs.",
  "The result: full coverage and no dead zones.",
];

const APS = [110, 250, 390];
const cable = (x, i) => `M${x},84 V${50 + i * 5} H${492 + i * 10} V118`;
const CLIENTS = [
  { x: 70, y: 300, icon: Laptop, ap: 110 },
  { x: 160, y: 330, icon: Smartphone, ap: 110 },
  { x: 250, y: 300, icon: Laptop, ap: 250 },
  { x: 350, y: 330, icon: Smartphone, ap: 390 },
  { x: 420, y: 295, icon: Laptop, ap: 390 },
];

const Rack = () => (
  <g>
    <rect x="470" y="100" width="110" height="250" rx="3" fill="#0D131E" stroke="#334155" />
    <rect x="476" y="106" width="4" height="238" fill="#1E293B" />
    <rect x="570" y="106" width="4" height="238" fill="#1E293B" />
    <rect x="482" y="112" width="86" height="16" rx="1.5" fill="#1F2937" stroke="#475569" strokeWidth="0.6" />
    {Array.from({ length: 12 }).map((_, i) => <rect key={i} x={486 + i * 6.6} y="117" width="4.6" height="6" fill="#0B0F17" />)}
    <Unit x={482} y={134} w={86} h={18} ports={6} sfp={1} screen={false} />
    <Unit x={482} y={158} w={86} h={18} ports={4} sfp={1} />
    {[184, 208, 232].map((y) => <rect key={y} x="482" y={y} width="86" height="18" rx="1.5" fill="#111827" stroke="#1F2937" />)}
  </g>
);

export const WifiAnim = ({ say }) => {
  useCycle(say, LINES);
  return (
  <Svg>
    <clipPath id="below"><rect x="0" y="84" width="470" height="316" /></clipPath>
    <line x1="20" y1="70" x2="470" y2="70" stroke="#334155" strokeDasharray="2 5" />
    <Label x={20} y={62} anchor="start">CEILING VOID</Label>
    <g clipPath="url(#below)">
      {APS.map((x, i) => [0, 1, 2].map((k) => (
        <circle key={`${i}-${k}`} cx={x} cy="84" r="150" fill="none" stroke={C.cyan} strokeOpacity="0.5" className="wave" style={{ animationDelay: `${k * 1 + i * 0.3}s` }} />
      )))}
    </g>
    <Pop delay={0.2}><Rack /></Pop>
    <Label x={525} y={92} color={C.text}>COMMS RACK</Label>
    <Label x={525} y={366} size={8}>PATCH · SWITCH · UDM</Label>
    {APS.map((x, i) => (
      <g key={x}>
        <Draw d={cable(x, i)} delay={0.4 + i * 0.25} color={C.blue} w={1.8} dur={1.4} />
        <Packet d={cable(x, i)} dur={2.4} begin={i * 0.5} color={C.cyan} />
        <Pop delay={0.3 + i * 0.15}><APDisc x={x} y={92} r={15} /></Pop>
        <Label x={x} y={126} color={C.text} size={8}>U7 PRO</Label>
        <Label x={x + 34} y={46 + i * 5} size={7} anchor="start">CAT6A · {28 + i * 9}m</Label>
      </g>
    ))}
    {CLIENTS.map((c, i) => (
      <g key={i}>
        <line x1={c.x} y1={c.y - 12} x2={c.ap} y2={110} stroke={C.cyan} strokeOpacity="0.25" strokeDasharray="2 6" className="flow" />
        <Pop delay={1 + i * 0.1}><Icon as={c.icon} x={c.x} y={c.y} s={20} color={C.text} /></Pop>
      </g>
    ))}
    <Label x={20} y={384} anchor="start">FULL COVERAGE · TIDY, LABELLED CABLING</Label>
  </Svg>
  );
};
